/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import ObjectType from './ObjectType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper, updatePropertyOverride
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass

/**
 * <p>Java class for itemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="itemType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;choice&gt; &lt;element ref="{}queryItem"/&gt; &lt;element ref="{}namedSet"/&gt; &lt;element ref="{}filter"/&gt; &lt;element name="folder"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element ref="{}itemHierarchy"/&gt; &lt;element ref="{}calculation"/&gt; &lt;/choice&gt; &lt;element name="positionAfter" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ItemType extends MoserObject{

	queryItem = null;

	namedSet = null;

	filter = null;

	folder = null;

	itemHierarchy = null;

	calculation = null;

	positionAfter = null;



	/**
	 * A projectable item referring to an underlying source item (column, level, attribute, named set) or a calculation based on such items.
	 * @return {QueryItem} possible object is {@link QueryItem}
	 */
	getQueryItem() {
		return this.queryItem;
	}

	/**
	 * Sets the value of the queryItem property.
	 * @param {QueryItem} value allowed object is {@link QueryItem}
	 */
	setQueryItem(value) {
		var oldValue = this.queryItem;
		this.queryItem = value;
		this._setAndNotify(37, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 37, true);
		}
	}

	/**
	 * Gets the value of the namedSet property.
	 * @return {NamedSet} possible object is {@link NamedSet}
	 */
	getNamedSet() {
		return this.namedSet;
	}

	/**
	 * Sets the value of the namedSet property.
	 * @param {NamedSet} value allowed object is {@link NamedSet}
	 */
	setNamedSet(value) {
		var oldValue = this.namedSet;
		this.namedSet = value;
		this._setAndNotify(68, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 68, true);
		}
	}

	/**
	 * Selectable/dragable filters.
	 * @return {Filter} possible object is {@link Filter}
	 */
	getFilter() {
		return this.filter;
	}

	/**
	 * Sets the value of the filter property.
	 * @param {Filter} value allowed object is {@link Filter}
	 */
	setFilter(value) {
		var oldValue = this.filter;
		this.filter = value;
		this._setAndNotify(10, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 10, true);
		}
	}

	/**
	 * Gets the value of the folder property.
	 * @return {Folder} possible object is {@link ItemType.Folder}
	 */
	getFolder() {
		return this.folder;
	}

	/**
	 * Sets the value of the folder property.
	 * @param {Folder} value allowed object is {@link ItemType.Folder}
	 */
	setFolder(value) {
		var oldValue = this.folder;
		this.folder = value;
		this._setAndNotify(101, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 101, true);
		}
	}

	/**
	 * Gets the value of the itemHierarchy property.
	 * @return {ItemHierarchy} possible object is {@link ItemHierarchy}
	 */
	getItemHierarchy() {
		return this.itemHierarchy;
	}

	/**
	 * Sets the value of the itemHierarchy property.
	 * @param {ItemHierarchy} value allowed object is {@link ItemHierarchy}
	 */
	setItemHierarchy(value) {
		var oldValue = this.itemHierarchy;
		this.itemHierarchy = value;
		this._setAndNotify(102, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 102, true);
		}
	}

	/**
	 * Gets the value of the calculation property.
	 * @return {Calculation} possible object is {@link Calculation}
	 */
	getCalculation() {
		return this.calculation;
	}

	/**
	 * Sets the value of the calculation property.
	 * @param {Calculation} value allowed object is {@link Calculation}
	 */
	setCalculation(value) {
		var oldValue = this.calculation;
		this.calculation = value;
		this._setAndNotify(61, oldValue, value, true, false);
		if (value) {
			MoserObject.updatePropertyOverride(value, this, 61, true);
		}
	}

	/**
	 * Gets the value of the positionAfter property.
	 * @return {String} possible object is {@link String}
	 */
	getPositionAfter() {
		return this.positionAfter;
	}

	/**
	 * Sets the value of the positionAfter property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPositionAfter(value) {
		var oldValue = this.positionAfter;
		this.positionAfter = value;
		this._setAndNotify(103, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>ItemType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ItemType</code> object from.
	 * @return {ItemType} an object of type <code>ItemType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createItemType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ItemType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createQueryItem().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 37, "queryItem", clazz));
		if (factory) {
			clazz = factory.createNamedSet().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 68, "namedSet", clazz));
		if (factory) {
			clazz = factory.createFilter().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 10, "filter", clazz));
		if (factory) {
			clazz = factory.createItemTypeFolder().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 101, "folder", clazz));
		if (factory) {
			clazz = factory.createItemHierarchy().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 102, "itemHierarchy", clazz));
		if (factory) {
			clazz = factory.createCalculation().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 61, "calculation", clazz));
		featureList.push(this.createFeature(false, false, false, 103, "positionAfter", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 37:
			this.setQueryItem((value));
			break;
		case 68:
			this.setNamedSet((value));
			break;
		case 10:
			this.setFilter((value));
			break;
		case 101:
			this.setFolder((value));
			break;
		case 102:
			this.setItemHierarchy((value));
			break;
		case 61:
			this.setCalculation((value));
			break;
		case 103:
			this.setPositionAfter((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 37:
			return this.getQueryItem();
		case 68:
			return this.getNamedSet();
		case 10:
			return this.getFilter();
		case 101:
			return this.getFolder();
		case 102:
			return this.getItemHierarchy();
		case 61:
			return this.getCalculation();
		case 103:
			return this.getPositionAfter();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 37:
			return this.getQueryItem();
		case 68:
			return this.getNamedSet();
		case 10:
			return this.getFilter();
		case 101:
			return this.getFolder();
		case 102:
			return this.getItemHierarchy();
		case 61:
			return this.getCalculation();
		case 103:
			return this.getPositionAfter();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
ItemType.Folder = class extends ObjectType{

	item = null;



	/**
	 * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemType}
	 */
	getItem() {
		if (!this.item) {
			this.item = [];
		}
		return this.item;
	}

	/**
	 * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ItemType</code> elements, or <code>null</code> if not set
	 */
	basicGetItem() {
		return this.item;
	}

	/**
	 * Creates a new instance of <code>Folder</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Folder</code> object from.
	 * @return {Folder} an object of type <code>Folder</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createItemTypeFolder();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addItemAt(position, item) {
		this._addAtAndNotify(this.getItem(), position, item, 11, true, false);
		var qi = item.getQueryItem();
		if (qi) {
			MoserObject.updatePropertyOverride(qi, this, 37, true);
		}
		var hierarchy = item.getItemHierarchy();
		if (hierarchy) {
			MoserObject.updatePropertyOverride(hierarchy, this, 102, true);
		}
		var namedSet = item.getNamedSet();
		if (namedSet) {
			MoserObject.updatePropertyOverride(namedSet, this, 68, true);
		}
		var filter = item.getFilter();
		if (filter) {
			MoserObject.updatePropertyOverride(filter, this, 10, true);
		}
		var folder = item.getFolder();
		if (folder) {
			MoserObject.updatePropertyOverride(folder, this, 101, true);
		}
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addItem(item) {
		this.addItemAt(this.getItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeItemAt(position) {
		this._removeAtAndNotify(this.getItem(), position, 11, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeItem(item) {
		var i = this.getItem().indexOf(item);
		if (i >= 0) {
			this.removeItemAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Folder";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createItemType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 11, "item", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 11:
			this.item = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 11:
			return this.getItem();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 11:
			return this.basicGetItem();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 11:
			this.addItemAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 11:
			this.addItem((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 11:
			this.removeItemAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 11:
			this.removeItem((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ItemType.js